import React from "react";
import {Divider} from "antd";

export default function DividerBlock({label, style={fontSize: "12pt", fontWeight: 100, color: "rgba(0, 0, 0, 0.45)"}}) {
    return (
        <Divider style={style}>
            {label}
        </Divider>
    );
}